import posthog from 'posthog-js'

export type TwilioWidgetErrorSource =
  | 'call_already_in_progress'
  | 'call_error'
  | 'call_rejected'
  | 'device_connect_failed'
  | 'device_error'
  | 'device_error_cleanup_failed'
  | 'device_setup_failed'
  | 'end_call_failed'
  | 'input_device_change_failed'
  | 'invalid_phone_number'
  | 'microphone_permission_denied'
  | 'mute_call_failed'
  | 'output_device_change_failed'
  | 'record_call_failed'
  | 'token_query_failed'
  | 'token_refresh_failed'
  | 'token_update_failed'
  | 'unmute_call_failed'

type TwilioWidgetErrorProperties = {
  error_source: TwilioWidgetErrorSource
  browser_permission?: 'microphone'
  call_status?: string
  device_state?: string
  has_active_call?: boolean
  has_call_from_error?: boolean
}

function errorDetails(error: unknown) {
  if (!error || typeof error !== 'object') {
    return {
      error_message: typeof error === 'undefined' ? undefined : String(error),
      error_type: typeof error,
    }
  }

  const details = error as {
    code?: unknown
    description?: unknown
    explanation?: unknown
    message?: unknown
    name?: unknown
  }

  return {
    error_code:
      typeof details.code === 'number' || typeof details.code === 'string'
        ? details.code
        : undefined,
    error_description:
      typeof details.description === 'string' ? details.description : undefined,
    error_explanation:
      typeof details.explanation === 'string' ? details.explanation : undefined,
    error_message:
      typeof details.message === 'string' ? details.message : undefined,
    error_name: typeof details.name === 'string' ? details.name : undefined,
  }
}

export function captureTwilioWidgetError(
  error: unknown,
  properties: TwilioWidgetErrorProperties,
) {
  const posthogProperties = {
    feature: 'twilio_widget',
    ...properties,
    ...errorDetails(error),
  }

  try {
    posthog.capture('twilio_widget_error', posthogProperties)
  } catch (error) {
    /**/
  }
}
